import {dispatchStateContext, globalStateContext} from '@/App.jsx';
import {Device} from '@/models/device';
import {getDevice} from '@/services/utility.js';
import {MyView, SimpleText} from '@/styles/CommonComponents.jsx';
import {SimpleTextIcon} from '@/styles/common/TextIcon.jsx';
import {styles} from '@/styles/common/styles.js';
import {faClose, faFilter} from '@fortawesome/free-solid-svg-icons';
import React, {useState} from 'react';
import {Pressable} from 'react-native';
import {useTheme} from 'styled-components';
import FilterItem from './FilterItem.jsx';
import {style} from './Style.jsx';
function Filter() {
  const useGlobalState = () => [
    React.useContext(globalStateContext),
    React.useContext(dispatchStateContext),
  ];
  const [state, dispatch] = useGlobalState();
  const device = getDevice();
  const isLargePage = device.indexOf(Device.Large) !== -1;
  const [filters, setFilters] = useState();
  const [monthFilter, setMonthFilter] = useState();
  const [allActive, setAllActive] = useState(true);
  const [selected, setSelected] = useState();
  const [selectedMonth, setSelectedMonth] = useState();
  const [allAvailable, setAllAvailable] = useState(false);
  const [allAvailableMonth, setAllAvailableMonth] = useState(false);
  const [allActiveMonth, setAllActiveMonth] = useState(true);
  const [selectedKindQuiz, setSelectedKindQuiz] = useState('all');
  const [selectedKindTag, setSelectedKindTag] = useState('all');
  const [selectedPrice, setSelectedPrice] = useState('all');
  const togglePrice = lbl => {
    setSelectedPrice(lbl);
    dispatch({
      loading: true,
    });
    state.onChangePrice(lbl);
    setTimeout(() => {
      dispatch({
        loading: false,
      });
    }, 3000);
  };
  const toggleKindQuiz = lbl => {
    setSelectedKindQuiz(lbl);
    dispatch({
      loading: true,
    });
    state.onChangeKindQuiz(lbl);
    setTimeout(() => {
      dispatch({
        loading: false,
      });
    }, 3000);
  };
  const toggleSelected = lbl => {
    const tmp = [];
    // console.log(selected);
    selected.forEach(itr => {
      tmp.push(itr);
    });
    // console.log(tmp);
    const tmpIdx = tmp.indexOf(lbl);
    if (tmpIdx === -1) tmp.push(lbl);
    else tmp.splice(tmpIdx, 1);
    if (allAvailable && allActive && tmp.length !== filters.length)
      setAllActive(false);

    // console.log(tmp);
    setSelected(tmp);
    dispatch({
      loading: true,
    });
    state.onChangeFilter(tmp);
    setTimeout(() => {
      dispatch({
        loading: false,
      });
    }, 3000);
  };
  const changeKindTag = lbl => {
    let tmpArr;
    if (lbl === 'all') tmpArr = allFilters;
    else if (lbl === 'hosh')
      tmpArr = allFilters.filter(e => {
        return e.indexOf('هوش') !== -1;
      });
    else if (lbl === 'olympiad')
      tmpArr = allFilters.filter(e => {
        return e.indexOf('المپیاد') !== -1;
      });
    dispatch({
      loading: true,
    });
    // setSelected(tmpArr);
    setSelected([]);
    state.onChangeFilter(tmpArr);
    setTimeout(() => {
      dispatch({
        loading: false,
      });
    }, 3000);
    setFilters([
      {
        subCats: tmpArr,
        label: 'تگ\u200cها',
      },
    ]);
    setSelectedKindTag(lbl);
  };
  // const toggleMonthSelected = lbl => {
  //   const tmpIdx = selectedMonth.indexOf(lbl);
  //   const tmp = selectedMonth;
  //   if (tmpIdx === -1) tmp.push(lbl);
  //   else tmp.splice(tmpIdx, 1);
  //   if (
  //     allAvailableMonth &&
  //     allActiveMonth &&
  //     tmp.length !== monthFilter.length
  //   )
  //     setAllActiveMonth(false);
  //   setSelectedMonth(tmp);
  //   state.onChangeFilterMonth(tmp);
  // };
  const setAllFilter = React.useCallback(() => {
    if (filters === undefined) return;
    if (!allAvailable || allActive) setSelected([]);
    dispatch({
      allFilter: allAvailable && allActive,
    });
  }, [dispatch, allActive, filters, allAvailable]);
  React.useEffect(() => {
    setAllFilter();
  }, [allActive, setAllFilter]);
  React.useEffect(() => {
    if (state.month === undefined) return;
    setSelectedMonth([]);
    setAllAvailableMonth(true);
    setMonthFilter(
      state.month.map(e => {
        return {
          status: false,
          label: e,
        };
      }),
    );
  }, [state.month]);
  const [allFilters, setAllFilters] = useState();
  React.useEffect(() => {
    if (!state.filters) return;
    if (state.filters instanceof Array) {
      setSelected(
        state.filters.map((_, index) => {
          return index;
        }),
      );
      setAllAvailable(true);
      setFilters(state.filters);
      setAllFilters(state.filters);
    } else if (state.filters instanceof Object) {
      const tmp = [];
      for (const [key, value] of Object.entries(state.filters)) {
        tmp.push({
          label: key,
          subCats: value,
        });
      }
      setAllFilters(tmp[0].subCats);
      setFilters(tmp);
    }
  }, [state.filters]);
  const [showFilterBox, setShowFilterBox] = useState(isLargePage);
  const theme = useTheme();

  return (
    <>
      {!isLargePage && (
        <Pressable
          onPress={() => setShowFilterBox(true)}
          style={{
            boxShadow: '0px 3px 16px 4px rgb(0 0 0 / 16%)',
            borderRadius: 10,
            padding: 10,
            backgroundColor: 'white',
            top: 0,
            height: 70,
            width: '100%',
            alignItems: 'stretch',
          }}>
          <SimpleTextIcon
            onPress={() => setShowFilterBox(true)}
            textStyle={{
              color: theme.colors.text.base,
              ...styles.alignSelfCenter,
              ...styles.fontSize20,
              ...styles.bold,
            }}
            iconStyle={{
              color: theme.colors.text.base,
              ...styles.alignSelfCenter,
            }}
            text={'نمایش فیلترها'}
            icon={faFilter}
          />
        </Pressable>
      )}
      {showFilterBox && (
        <div
          className="menu-item-container filter"
          style={
            isLargePage
              ? style.MenuJustLarge
              : {
                  position: 'fixed',
                  top: -10,
                  zIndex: 10,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'white',
                  overflow: 'auto',
                }
          }>
          {isLargePage && (
            <SimpleText
              style={{
                ...styles.padding10,
                ...styles.margin15,
                ...styles.bold,
                ...{
                  color: theme.colors.text.base,
                  borderBottomWidth: 2,
                  borderColor: theme.colors.text.base,
                },
              }}
              text={'نتایج را بهینه کنید'}
            />
          )}
          {!isLargePage && (
            <SimpleTextIcon
              onPress={() => setShowFilterBox(false)}
              textStyle={{
                color: theme.colors.text.base,
                ...styles.alignSelfCenter,
                ...styles.fontSize20,
                ...styles.bold,
              }}
              iconStyle={{
                color: theme.colors.text.base,
                ...styles.alignSelfCenter,
              }}
              text={'نتایج را بهینه کنید'}
              icon={faClose}
            />
          )}

          {state.selectableItems !== undefined && state.allItems !== undefined && (
            <SimpleText
              style={{
                ...styles.margin15,
                color: theme.colors.text.base,
                ...styles.bold,
                ...{
                  borderBottomWidth: 2,
                  borderColor: theme.colors.text.base,
                  padding: isLargePage ? 10 : 30,
                },
              }}
              text={
                'نمایش ' +
                state.selectableItems +
                ' مورد از ' +
                state.allItems +
                ' مورد'
              }
            />
          )}

          {(state.relativeFilterOn === undefined || state.relativeFilterOn) && (
            <>
              <SimpleText
                style={{
                  ...styles.paddingTop10,
                  ...styles.marginLeft15,
                  ...styles.marginRight15,
                  color: theme.colors.text.base,
                  ...styles.bold,
                }}
                text={'دنبال چه آزمونی می‌گردی؟'}
              />
              <MyView
                style={{
                  ...{
                    borderBottomWidth: 2,
                    borderColor: theme.colors.text.base,
                    margin: 3,
                  },
                }}>
                <FilterItem
                  item={{
                    label: 'هوش',
                  }}
                  status={selectedKindTag === 'hosh' ? 'checked' : 'unchecked'}
                  onPress={_ => changeKindTag('hosh')}
                />
                <FilterItem
                  item={{
                    label: 'المپیاد',
                  }}
                  status={
                    selectedKindTag === 'olympiad' ? 'checked' : 'unchecked'
                  }
                  onPress={_ => changeKindTag('olympiad')}
                />
                <FilterItem
                  item={{
                    label: 'همه رو ببینم',
                  }}
                  status={selectedKindTag === 'all' ? 'checked' : 'unchecked'}
                  onPress={_ => changeKindTag('all')}
                />
              </MyView>
            </>
          )}

          {(state.timeFilterOn === undefined || state.timeFilterOn) && (
            <>
              <SimpleText
                style={{
                  ...styles.padding10,
                  color: theme.colors.text.base,
                  ...styles.bold,
                  ...styles.marginRight15,
                }}
                text={'میخوای چه زمانی باشه؟'}
              />
              <MyView
                style={{
                  ...{
                    borderBottomWidth: 2,
                    borderColor: theme.colors.text.base,
                    margin: 3,
                  },
                }}>
                <FilterItem
                  item={{
                    label: 'آزمون باز (تاریخ آزاده)',
                  }}
                  status={selectedKindQuiz === 'open' ? 'checked' : 'unchecked'}
                  onPress={_ => toggleKindQuiz('open')}
                />
                <FilterItem
                  item={{
                    label: 'آزمون پشت میز (تاریخ مشخصه)',
                  }}
                  status={
                    selectedKindQuiz === 'regular' ? 'checked' : 'unchecked'
                  }
                  onPress={_ => toggleKindQuiz('regular')}
                />

                <FilterItem
                  item={{
                    label: 'آزمون فرار',
                  }}
                  status={
                    selectedKindQuiz === 'escape' ? 'checked' : 'unchecked'
                  }
                  onPress={_ => toggleKindQuiz('escape')}
                />

                {/* <FilterItem
                 item={{label: 'آزمون پای تخته (تاریخ مشخصه)'}}
                 status={
                 selectedKindQuiz === 'onlineStanding' ? 'checked' : 'unchecked'
                 }
                 onPress={label => toggleKindQuiz('onlineStanding')}
                 /> */}

                <FilterItem
                  item={{
                    label: 'همه رو ببینم',
                  }}
                  status={selectedKindQuiz === 'all' ? 'checked' : 'unchecked'}
                  onPress={_ => toggleKindQuiz('all')}
                />
              </MyView>
            </>
          )}
          <SimpleText
            style={{
              ...styles.padding10,
              color: theme.colors.text.base,
              ...styles.bold,
              ...styles.marginRight15,
            }}
            text={'مربوط به چی باشه؟'}
          />
          <MyView
            style={{
              ...styles.marginLeft15,
              ...styles.marginRight15,
              ...styles.marginTop0,
              ...styles.gap10,
            }}>
            {filters &&
              filters.map((elem, index) => {
                return (
                  <FilterItem
                    item={elem}
                    status={allActive ? 'unchecked' : undefined}
                    selected={selected}
                    key={index}
                    onPress={label => toggleSelected(label)}
                  />
                );
              })}
          </MyView>

          {/* {monthFilter !== undefined && (
            <>
              <SimpleText
                style={{
                  ...styles.paddingTop10,
                  ...styles.marginLeft15,
                  ...styles.marginRight15,
                  color: theme.colors.text.base,...styles.bold,
                }}
                text={'ماه برگزاری'}
              />
              <MyView
                style={{
                  ...styles.paddingTop10,
                  ...styles.marginLeft15,
                  ...styles.marginRight15,
                  ...styles.marginTop0,
                  ...styles.gap10,
                }}>
                {monthFilter !== undefined &&
                  monthFilter.map((elem, index) => {
                    return (
                      <FilterItem
                        item={elem}
                        status={allActiveMonth ? 'unchecked' : undefined}
                        key={index}
                        checkbox={true}
                        onPress={label => toggleMonthSelected(label)}
                      />
                    );
                  })}
              </MyView>
            </>
           )} */}

          {allAvailable && (
            <FilterItem
              item={{
                label: 'همه',
              }}
              onPress={() => {
                if (!allActive) setAllActive(true);
              }}
              status={allActive ? 'checked' : 'unchecked'}
              isAll={true}
            />
          )}
          {(state.priceFilterOn === undefined || state.priceFilterOn) && (
            <>
              <SimpleText
                style={{
                  ...styles.padding10,
                  color: theme.colors.text.base,
                  ...styles.bold,
                  ...styles.marginRight15,
                }}
                text={'آزمون رایگان باشه یا پولی؟'}
              />
              <MyView
                style={{
                  ...{
                    borderBottomWidth: 2,
                    borderColor: theme.colors.text.base,
                    margin: 10,
                  },
                }}>
                <FilterItem
                  item={{
                    label: 'رایگان',
                  }}
                  status={selectedPrice === 'free' ? 'checked' : 'unchecked'}
                  onPress={_ => togglePrice('free')}
                />
                <FilterItem
                  item={{
                    label: 'غیر رایگان',
                  }}
                  status={selectedPrice === 'nonFree' ? 'checked' : 'unchecked'}
                  onPress={_ => togglePrice('nonFree')}
                />
                <FilterItem
                  item={{
                    label: 'همه',
                  }}
                  status={selectedPrice === 'all' ? 'checked' : 'unchecked'}
                  onPress={_ => togglePrice('all')}
                />
              </MyView>
            </>
          )}
        </div>
      )}
    </>
  );
}
export default Filter;
